// extracted by mini-css-extract-plugin
module.exports = {"XS":"0","SM":"450px","MD":"768px","LG":"1025px","XL":"1250px"};